<a href="#main-content" class="skip-link">Skip to main content</a>
<app-donate-banner></app-donate-banner>
<app-header></app-header>
<main id="main-content">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<app-cookie-banner></app-cookie-banner>
